import "./Navbar.css";
import { Link, useNavigate } from "react-router-dom";

function Navbar() {
  const navigate = useNavigate();
  const handleLoginClick = () => {
    navigate("/login");
  };
  return (
    <>
      <header className="header">
        <div className="header-container">
          <div className="logo">
            {/* Vector1.svg */}
            <Link to="/">
              <img
                src="/assets/images/Navbar/new_logo.png"
                alt="Clybourne Logo"
              />
            </Link>
          </div>
          <nav className="nav">
            <ul>
              <li>
                <Link to="/product">Product</Link>
              </li>
              <li>
                <Link to="/methodology">Methodology</Link>
              </li>
              <li>
                <Link to="/pricing">Pricing</Link>
              </li>
              <li>
                <Link to="/about">About Us</Link>
              </li>
              <li>
                <Link to="/resources">Resource</Link>
              </li>
              <li>
                <Link to="/contact">Contact Us</Link>
              </li>
            </ul>
            <div className="auth-button">
              <button onClick={handleLoginClick}>Login/Sign Up</button>
            </div>
          </nav>
        </div>
      </header>
    </>
  );
}

export default Navbar;
